import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0a0a0a]/95 backdrop-blur-md border-b border-[#1f1f1f]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 lg:px-16 flex items-center justify-between h-20">
        {/* Logo */}
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollTo("home")}>
          <img
            src="https://static.readdy.ai/image/a0761e962eb5c291c08d71c2c83d99b3/61ecfeb16ca96e33a151f9b888933dc5.png"
            alt="Imperial Digital Logo"
            className="h-10 w-auto object-contain"
          />
          <span className="text-white font-semibold text-lg tracking-wide hidden sm:block" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Imperial <span className="text-[#C9A227]">Digital</span>
          </span>
        </div>

        {/* Desktop Nav Links */}
        <div className="hidden md:flex items-center gap-10">
          {[
            { label: "Inicio", id: "home" },
            { label: "Servicios", id: "servicios" },
            { label: "Por qué nosotros", id: "porque" },
            { label: "Contacto", id: "contacto" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-gray-300 hover:text-[#C9A227] text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* CTA Button */}
        <button
          onClick={() => scrollTo("contacto")}
          className="hidden md:block bg-[#C9A227] hover:bg-[#b8911e] text-black text-sm font-bold px-6 py-2.5 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          Solicitar información
        </button>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-white w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${menuOpen ? "close" : "menu"}-line text-2xl`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0a0a0a] border-t border-[#1f1f1f] px-8 py-6 flex flex-col gap-5">
          {[
            { label: "Inicio", id: "home" },
            { label: "Servicios", id: "servicios" },
            { label: "Por qué nosotros", id: "porque" },
            { label: "Contacto", id: "contacto" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-gray-300 hover:text-[#C9A227] text-sm font-medium tracking-wide transition-colors duration-200 text-left cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("contacto")}
            className="bg-[#C9A227] hover:bg-[#b8911e] text-black text-sm font-bold px-6 py-2.5 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer w-full"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Solicitar información
          </button>
        </div>
      )}
    </nav>
  );
}
